export default __webpack_public_path__ + "assets/images/d2046a44371d20cb7723094f15cfdec0-instructions-account-link.gif";